import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PaginatedEntityTable } from "components/common";
import { fetchPaginatedCollections, keyFn } from "collections/hooks/useCollections";
import CollectionActions from "./CollectionActions";
import customColumnRenderers from "./customColumnRenderers";
import BulkActions from "./BulkActions";
export const DEFAULT_LAYOUT = {
  entityTableId: "collections",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "description", "shared_with_users", "shared_with_teams"],
  defaultColumnOrder: ["title", "description", "shared_with_users", "shared_with_teams"]
};
const bulkSelection = {
  actions: /* @__PURE__ */ React.createElement(BulkActions, null)
};
const CollectionsList = () => {
  const { t } = useTranslation("enterprise_collections");
  const collectionActions = useCallback(
    ({ id, title }) => /* @__PURE__ */ React.createElement(CollectionActions, { id, title }),
    []
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("human_names.collections"),
      entityActions: collectionActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchPaginatedCollections,
      keyFn,
      columnRenderers: customColumnRenderers,
      entityAttributesAreCamelCase: false,
      searchPlaceholder: t("lists.search_collection"),
      bulkSelection
    }
  );
};
export default CollectionsList;
